import { FC } from 'react'
import { Outlet } from 'react-router-dom'

// COMPONENTS
import { Column } from '@components/templates/column'

// ROUTES
import { TargetRoute } from './target'
import { PledgeIdRoute } from './[pledgeId]'

// TYPES
import type { RouteObject } from 'react-router-dom'


const Layout: FC<{}> = () => {
    return (
        <Column.Content className="group-edit-screen">
            <Outlet />
        </Column.Content>
    )
}

const EditRoute: RouteObject = {
    path: 'edit',
    element: <Layout />,
    children: [
        TargetRoute,
        PledgeIdRoute,
    ]
}

export default EditRoute